<table>
  <tr>
    <td>
      <div>
        <input type="text" #username [disabled]="synchronizing" placeholder="{{'Tên đăng nhập' | lang}}" />
        <input class="std-margin-top std-margin-bottom" type="password" #password [disabled]="synchronizing" placeholder="{{'Mật khẩu' | lang}}" />
        <button class="bg-success bold text-white" (click)="login(username.value, password.value)" [disabled]="synchronizing"><span>{{'Đăng nhập' | lang}}</span></button>
      </div>
    </td>
  </tr>
</table>
